import { useEffect } from "react";
import Center from "../components/utils/Center";

interface Props {}

const GlossaryPage = ({}: Props) => {

  const terms = [
    {
      term: "Tuttobanana",
      definition: "To send a joyful, animated digital banana to someone you care about. The verb of the Bananaverse.",
    },
    {
      term: "Tutto",
      definition: "A member of the Bananaverse. Anyone who sends a banana is a Tutto. Welcome, legend!",
    },
    {
      term: "Bananatee",
      definition: "A lucky recipient of a Tuttobanana, chosen to catch the joy and keep the smile moving.",
    },
    {
      term: "Banana Stand",
      definition: "The place where you pick your next banana gift. Think of it as your fruity arsenal.",
    },
    {
      term: "Bananergy",
      definition: "The contagious emotional energy created by sending and receiving bananas. Pure, clean vibes.",
    },
    {
      term: "Banana Forward",
      definition: "Sharing the same banana with someone new, passing the joy forward.",
    },
    {
      term: "Banana Back",
      definition: "Sending the banana back to the original sender, like a joyful boomerang of love.",
    },
    {
      term: "Bananaverse",
      definition: "The ever-growing universe of banana connections. Track travels, stats, and smiles.",
    },
  ];

  return (
    <>
      <title>Glossary | Tuttobanana</title>
      <meta name="description" content="Bananafused? Our glossary breaks down all the fruity terms of Tuttobanana so you're never lost in the Bananaverse." />

      <div className="bg-gray-100 text-gray-900 px-6 py-20 sm:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold mb-12 text-center text-yellow-500">
            Bananaverse Glossary
          </h1>
          <dl className="space-y-10">
            {terms.map(({ term, definition }) => (
              <div key={term}>
                <dt className="text-xl font-semibold text-gray-900">{term}</dt>
                <dd className="text-gray-700 mt-2">{definition}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </>
  );
};

export default GlossaryPage;
